/**
 * Base URL para chat IA, métricas públicas, etc.
 * En producción nunca usar http://localhost (provoca mixed content si el sitio va por HTTPS).
 */
const DEV_DEFAULT = 'http://localhost:3813/api/v1';
const PROD_DEFAULT = 'https://api.crosspaysolutions.com/api/v1';

const raw = (process.env.REACT_APP_API_URL || '').trim().replace(/\/+$/, '');
const API_BASE_URL =
  raw ||
  (process.env.NODE_ENV === 'development' ? DEV_DEFAULT : PROD_DEFAULT);

export default API_BASE_URL;
